import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-85bb027e")

_pushScopeId("data-v-85bb027e")
const _hoisted_1 = { class: "register-wrapper register-wrapper--desktop flex flex--h flex--width flex--halign-c flex--gap-50" }
const _hoisted_2 = { class: "flex flex--width flex--v flex--valign-c flex--gap-20" }
const _hoisted_3 = { class: "text text--size-20 text--primary-b text--semi-bold text--center" }
const _hoisted_4 = { class: "flex flex--width flex--v flex--valign-c flex--gap-20" }
const _hoisted_5 = { class: "text text--size-20 text--primary-b text--semi-bold text--center" }
const _hoisted_6 = { class: "register-wrapper register-wrapper--mobile flex flex--v flex--width flex--valign-c flex--gap-50" }
const _hoisted_7 = { class: "flex flex--width flex--v flex--valign-c flex--gap-20" }
const _hoisted_8 = { class: "text text--size-20 text--primary-b text--semi-bold text--center" }
const _hoisted_9 = { class: "flex flex--width flex--v flex--valign-c flex--gap-20" }
const _hoisted_10 = { class: "text text--size-20 text--primary-b text--semi-bold text--center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BreezeValidationErrors = _resolveComponent("BreezeValidationErrors")
  const _component_RegisterForm = _resolveComponent("RegisterForm")
  const _component_Plane = _resolveComponent("Plane")
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('auth.register')
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Plane, { darker: true }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$trans("auth.register_company")), 1),
              _createVNode(_component_BreezeValidationErrors, { class: "mb-4" }),
              _createVNode(_component_RegisterForm, {
                form: _ctx.formCompany,
                onSubmit: _withModifiers(_ctx.submitCompany, ["prevent"])
              }, null, 8, ["form", "onSubmit"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Plane, { darker: true }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$trans("auth.register_school")), 1),
              _createVNode(_component_BreezeValidationErrors, { class: "mb-4" }),
              _createVNode(_component_RegisterForm, {
                form: _ctx.formSchool,
                onSubmit: _withModifiers(_ctx.submitSchool, ["prevent"])
              }, null, 8, ["form", "onSubmit"])
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", {
          class: ["register-wrapper-choose flex flex--v flex--valign-c flex--gap-30", { 'register-wrapper-choose--margin': !_ctx.selectedForm }]
        }, [
          (!_ctx.selectedForm)
            ? (_openBlock(), _createBlock(_component_GenericButton, {
                key: 0,
                title: _ctx.$trans('auth.register_company'),
                secondary: true,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedForm = 'company'))
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          (!_ctx.selectedForm)
            ? (_openBlock(), _createBlock(_component_GenericButton, {
                key: 1,
                title: _ctx.$trans('auth.register_school'),
                secondary: true,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedForm = 'school'))
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          (_ctx.selectedForm)
            ? (_openBlock(), _createBlock(_component_GenericButton, {
                key: 2,
                title: _ctx.$trans('main.button_back'),
                identifier: 'arrow_left',
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedForm = null))
              }, null, 8, ["title"]))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.selectedForm === 'company')
          ? (_openBlock(), _createBlock(_component_Plane, {
              key: 0,
              darker: true
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_7, [
                  _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$trans("auth.register_company")), 1),
                  _createVNode(_component_BreezeValidationErrors, { class: "mb-4" }),
                  _createVNode(_component_RegisterForm, {
                    form: _ctx.formCompany,
                    onSubmit: _withModifiers(_ctx.submitCompany, ["prevent"])
                  }, null, 8, ["form", "onSubmit"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.selectedForm === 'school')
          ? (_openBlock(), _createBlock(_component_Plane, {
              key: 1,
              darker: true
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_9, [
                  _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$trans("auth.register_school")), 1),
                  _createVNode(_component_BreezeValidationErrors, { class: "mb-4" }),
                  _createVNode(_component_RegisterForm, {
                    form: _ctx.formSchool,
                    onSubmit: _withModifiers(_ctx.submitSchool, ["prevent"])
                  }, null, 8, ["form", "onSubmit"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
})